import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Actions = styled(Grid)({
  display: "flex",
  flexFlow: "column",
  alignContent: "start",
  padding: "1px 1px",
});
